// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/workflow_automation_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { AutoExecutionHistoryEntry } from "./workflow_automation_history_model_pb";
import { file_bffuser_v1_workflow_automation_history_model } from "./workflow_automation_history_model_pb";
import type { DemandAutoConfirmMethod, WorkflowSection } from "./workflow_template_model_pb";
import { file_bffuser_v1_workflow_template_model } from "./workflow_template_model_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/workflow_automation_service.proto.
 */
export const file_bffuser_v1_workflow_automation_service: GenFile = /*@__PURE__*/
  fileDesc("CixiZmZ1c2VyL3YxL3dvcmtmbG93X2F1dG9tYXRpb25fc2VydmljZS5wcm90bxIKYmZmdXNlci52MSIqCihHZXRXb3JrZmxvd0F1dG9tYXRpb25BdmFpbGFiaWxpdHlSZXF1ZXN0IqMBCilHZXRXb3JrZmxvd0F1dG9tYXRpb25BdmFpbGFiaWxpdHlSZXNwb25zZRIXCg9mZWF0dXJlX2VuYWJsZWQYASABKAgSXQoiZGVtYW5kX2F1dG9fY29uZmlybV9tZXRob2Rfb3B0aW9ucxgCIAMoCzIxLmJmZnVzZXIudjEuRGVtYW5kQXV0b0NvbmZpcm1TZWN0aW9uTWV0aG9kT3B0aW9ucyLTAQolRGVtYW5kQXV0b0NvbmZpcm1TZWN0aW9uTWV0aG9kT3B0aW9ucxIsCgdzZWN0aW9uGAEgASgOMhsuYmZmdXNlci52MS5Xb3JrZmxvd1NlY3Rpb24SOgoHbWV0aG9kcxgCIAMoCzIpLmJmZnVzZXIudjEuRGVtYW5kQXV0b0NvbmZpcm1NZXRob2RPcHRpb24SQAoNb3RoZXJfbWV0aG9kcxgDIAMoCzIpLmJmZnVzZXIudjEuRGVtYW5kQXV0b0NvbmZpcm1NZXRob2RPcHRpb24iaAodRGVtYW5kQXV0b0NvbmZpcm1NZXRob2RPcHRpb24SMwoGbWV0aG9kGAEgASgOMiMuYmZmdXNlci52MS5EZW1hbmRBdXRvQ29uZmlybU1ldGhvZBISCgpzZWxlY3RhYmxlGAIgASgIIlwKH0xpc3RBdXRvRXhlY3V0aW9uSGlzdG9yeVJlcXVlc3QSFQoEcGFnZRgCIAEoBUIHukgEGgIoARIcCglwYWdlX3NpemUYAyABKAVCCbpIBhoEGGQoAUoECAEQAiJvCiBMaXN0QXV0b0V4ZWN1dGlvbkhpc3RvcnlSZXNwb25zZRI2CgdlbnRyaWVzGAEgAygLMiUuYmZmdXNlci52MS5BdXRvRXhlY3V0aW9uSGlzdG9yeUVudHJ5EhMKC3RvdGFsX2NvdW50GAIgASgFIiMKIUdldEF1dG9tYXRpb25TZXR0aW5nQ291bnRzUmVxdWVzdCJoCiJHZXRBdXRvbWF0aW9uU2V0dGluZ0NvdW50c1Jlc3BvbnNlEhsKE2F1dG9fYmlkX3J1bGVfY291bnQYASABKAUSJQodcGxhbl9hdXRvbWF0ZWRfc3ViX3N0ZXBfY291bnQYAiABKAUyqAMKGVdvcmtmbG93QXV0b21hdGlvblNlcnZpY2USkgEKIUdldFdvcmtmbG93QXV0b21hdGlvbkF2YWlsYWJpbGl0eRI0LmJmZnVzZXIudjEuR2V0V29ya2Zsb3dBdXRvbWF0aW9uQXZhaWxhYmlsaXR5UmVxdWVzdBo1LmJmZnVzZXIudjEuR2V0V29ya2Zsb3dBdXRvbWF0aW9uQXZhaWxhYmlsaXR5UmVzcG9uc2UiABJ3ChhMaXN0QXV0b0V4ZWN1dGlvbkhpc3RvcnkSKy5iZmZ1c2VyLnYxLkxpc3RBdXRvRXhlY3V0aW9uSGlzdG9yeVJlcXVlc3QaLC5iZmZ1c2VyLnYxLkxpc3RBdXRvRXhlY3V0aW9uSGlzdG9yeVJlc3BvbnNlIgASfQoaR2V0QXV0b21hdGlvblNldHRpbmdDb3VudHMSLS5iZmZ1c2VyLnYxLkdldEF1dG9tYXRpb25TZXR0aW5nQ291bnRzUmVxdWVzdBouLmJmZnVzZXIudjEuR2V0QXV0b21hdGlvblNldHRpbmdDb3VudHNSZXNwb25zZSIAQkBaPmdpdGh1Yi5jb20vZW5lY2hhaW4vZWJhbGFuY2UvZ28vZ2VuL3Byb3RvL2JmZnVzZXIvdjE7YmZmdXNlcnYxYgZwcm90bzM", [file_bffuser_v1_workflow_automation_history_model, file_bffuser_v1_workflow_template_model, file_buf_validate_validate]);

/**
 * @generated from message bffuser.v1.GetWorkflowAutomationAvailabilityRequest
 */
export type GetWorkflowAutomationAvailabilityRequest = Message<"bffuser.v1.GetWorkflowAutomationAvailabilityRequest"> & {
};

/**
 * Describes the message bffuser.v1.GetWorkflowAutomationAvailabilityRequest.
 * Use `create(GetWorkflowAutomationAvailabilityRequestSchema)` to create a new message.
 */
export const GetWorkflowAutomationAvailabilityRequestSchema: GenMessage<GetWorkflowAutomationAvailabilityRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_automation_service, 0);

/**
 * @generated from message bffuser.v1.GetWorkflowAutomationAvailabilityResponse
 */
export type GetWorkflowAutomationAvailabilityResponse = Message<"bffuser.v1.GetWorkflowAutomationAvailabilityResponse"> & {
  /**
   * @generated from field: bool feature_enabled = 1;
   */
  featureEnabled: boolean;

  /**
   * @generated from field: repeated bffuser.v1.DemandAutoConfirmSectionMethodOptions demand_auto_confirm_method_options = 2;
   */
  demandAutoConfirmMethodOptions: DemandAutoConfirmSectionMethodOptions[];
};

/**
 * Describes the message bffuser.v1.GetWorkflowAutomationAvailabilityResponse.
 * Use `create(GetWorkflowAutomationAvailabilityResponseSchema)` to create a new message.
 */
export const GetWorkflowAutomationAvailabilityResponseSchema: GenMessage<GetWorkflowAutomationAvailabilityResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_automation_service, 1);

/**
 * @generated from message bffuser.v1.DemandAutoConfirmSectionMethodOptions
 */
export type DemandAutoConfirmSectionMethodOptions = Message<"bffuser.v1.DemandAutoConfirmSectionMethodOptions"> & {
  /**
   * @generated from field: bffuser.v1.WorkflowSection section = 1;
   */
  section: WorkflowSection;

  /**
   * @generated from field: repeated bffuser.v1.DemandAutoConfirmMethodOption methods = 2;
   */
  methods: DemandAutoConfirmMethodOption[];

  /**
   * @generated from field: repeated bffuser.v1.DemandAutoConfirmMethodOption other_methods = 3;
   */
  otherMethods: DemandAutoConfirmMethodOption[];
};

/**
 * Describes the message bffuser.v1.DemandAutoConfirmSectionMethodOptions.
 * Use `create(DemandAutoConfirmSectionMethodOptionsSchema)` to create a new message.
 */
export const DemandAutoConfirmSectionMethodOptionsSchema: GenMessage<DemandAutoConfirmSectionMethodOptions> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_automation_service, 2);

/**
 * @generated from message bffuser.v1.DemandAutoConfirmMethodOption
 */
export type DemandAutoConfirmMethodOption = Message<"bffuser.v1.DemandAutoConfirmMethodOption"> & {
  /**
   * @generated from field: bffuser.v1.DemandAutoConfirmMethod method = 1;
   */
  method: DemandAutoConfirmMethod;

  /**
   * @generated from field: bool selectable = 2;
   */
  selectable: boolean;
};

/**
 * Describes the message bffuser.v1.DemandAutoConfirmMethodOption.
 * Use `create(DemandAutoConfirmMethodOptionSchema)` to create a new message.
 */
export const DemandAutoConfirmMethodOptionSchema: GenMessage<DemandAutoConfirmMethodOption> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_automation_service, 3);

/**
 * ListAutoExecutionHistoryRequest carries no organization_id; the BFF handler
 * resolves the organization from the eauth session.
 *
 * @generated from message bffuser.v1.ListAutoExecutionHistoryRequest
 */
export type ListAutoExecutionHistoryRequest = Message<"bffuser.v1.ListAutoExecutionHistoryRequest"> & {
  /**
   * page is 1-based.
   *
   * @generated from field: int32 page = 2;
   */
  page: number;

  /**
   * @generated from field: int32 page_size = 3;
   */
  pageSize: number;
};

/**
 * Describes the message bffuser.v1.ListAutoExecutionHistoryRequest.
 * Use `create(ListAutoExecutionHistoryRequestSchema)` to create a new message.
 */
export const ListAutoExecutionHistoryRequestSchema: GenMessage<ListAutoExecutionHistoryRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_automation_service, 4);

/**
 * @generated from message bffuser.v1.ListAutoExecutionHistoryResponse
 */
export type ListAutoExecutionHistoryResponse = Message<"bffuser.v1.ListAutoExecutionHistoryResponse"> & {
  /**
   * @generated from field: repeated bffuser.v1.AutoExecutionHistoryEntry entries = 1;
   */
  entries: AutoExecutionHistoryEntry[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message bffuser.v1.ListAutoExecutionHistoryResponse.
 * Use `create(ListAutoExecutionHistoryResponseSchema)` to create a new message.
 */
export const ListAutoExecutionHistoryResponseSchema: GenMessage<ListAutoExecutionHistoryResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_automation_service, 5);

/**
 * GetAutomationSettingCountsRequest carries no organization_id; the BFF
 * handler resolves the organization from the eauth session.
 *
 * @generated from message bffuser.v1.GetAutomationSettingCountsRequest
 */
export type GetAutomationSettingCountsRequest = Message<"bffuser.v1.GetAutomationSettingCountsRequest"> & {
};

/**
 * Describes the message bffuser.v1.GetAutomationSettingCountsRequest.
 * Use `create(GetAutomationSettingCountsRequestSchema)` to create a new message.
 */
export const GetAutomationSettingCountsRequestSchema: GenMessage<GetAutomationSettingCountsRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_automation_service, 6);

/**
 * @generated from message bffuser.v1.GetAutomationSettingCountsResponse
 */
export type GetAutomationSettingCountsResponse = Message<"bffuser.v1.GetAutomationSettingCountsResponse"> & {
  /**
   * @generated from field: int32 auto_bid_rule_count = 1;
   */
  autoBidRuleCount: number;

  /**
   * @generated from field: int32 plan_automated_sub_step_count = 2;
   */
  planAutomatedSubStepCount: number;
};

/**
 * Describes the message bffuser.v1.GetAutomationSettingCountsResponse.
 * Use `create(GetAutomationSettingCountsResponseSchema)` to create a new message.
 */
export const GetAutomationSettingCountsResponseSchema: GenMessage<GetAutomationSettingCountsResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_automation_service, 7);

/**
 * WorkflowAutomationService exposes the global workflow-automation release
 * decision to authenticated browser sessions.
 *
 * @generated from service bffuser.v1.WorkflowAutomationService
 */
export const WorkflowAutomationService: GenService<{
  /**
   * @generated from rpc bffuser.v1.WorkflowAutomationService.GetWorkflowAutomationAvailability
   */
  getWorkflowAutomationAvailability: {
    methodKind: "unary";
    input: typeof GetWorkflowAutomationAvailabilityRequestSchema;
    output: typeof GetWorkflowAutomationAvailabilityResponseSchema;
  },
  /**
   * ListAutoExecutionHistory returns the session organization's 自動実行履歴
   * newest first, with repeated skipped / failed / held attempts merged
   * (auto-execution-history.md AC-AEH-005 / 006). Empty while workflow
   * automation is not released.
   *
   * @generated from rpc bffuser.v1.WorkflowAutomationService.ListAutoExecutionHistory
   */
  listAutoExecutionHistory: {
    methodKind: "unary";
    input: typeof ListAutoExecutionHistoryRequestSchema;
    output: typeof ListAutoExecutionHistoryResponseSchema;
  },
  /**
   * GetAutomationSettingCounts returns the session organization's counts
   * shown beside the entries to the automation settings
   * (auto-execution-history.md AC-AEH-010).
   *
   * @generated from rpc bffuser.v1.WorkflowAutomationService.GetAutomationSettingCounts
   */
  getAutomationSettingCounts: {
    methodKind: "unary";
    input: typeof GetAutomationSettingCountsRequestSchema;
    output: typeof GetAutomationSettingCountsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_workflow_automation_service, 0);

